import PopupTemplate from "@arcgis/core/PopupTemplate";

const intersectingForestMaskLayerPopup = new PopupTemplate({
    title: "Lähimetsä",
    outFields: ["area"],
    content: [{ type: "fields" }],
    fieldInfos: [{
        fieldName: "area",
        label: "Pinta-ala (ha)",
        format: {
            places: 1,
            digitSeparator: true
        }
    }]
});

export default intersectingForestMaskLayerPopup;